import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { Planner } from "@app/models/rest/planner";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { MatListOption, MatSelectionList } from "@angular/material/list";
import { Team } from "@app/models/rest/team";
import { TeamStore } from "@app/services/store/team-store";
import { PlannerStore } from "@app/services/store/planner-store";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-team-planner-add",
  templateUrl: "./team-planner-add.component.html",
  styleUrls: ["./team-planner-add.component.scss"],
  imports: [
    MatToolbar,
    MatDialogTitle,
    MatIconButton,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    MatSelectionList,
    MatListOption,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class TeamPlannerAddComponent implements OnInit {
  teamStore = inject(TeamStore);
  plannerStore = inject(PlannerStore);
  dialogRef = inject<MatDialogRef<TeamPlannerAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  team: Team;
  @ViewChild("plannerSelect", { static: false })
  plannerSelect: MatSelectionList;
  public plannerList: Planner[];

  constructor() {
    const data = this.data;

    console.log(data);
    this.team = data.resource;
  }

  ngOnInit() {
    if (!this.team || !this.team.getSelfLinkHref) return; // or show error
    this.plannerStore
      .loadWithSearch(
        "findByTeamListNotContaining",
        {
          params: {
            team: this.team.getSelfLinkHref(),
            projection: "detail"
          }
        },
        true
      )
      .then((plannerList) => (this.plannerList = plannerList.resources));
  }

  async onSelectClick() {
    console.log("select");
    console.log(this.plannerSelect.selectedOptions.selected);

    this.processNextTeamLink(this.plannerSelect.selectedOptions.selected);

    this.dialogRef.afterClosed().subscribe((result) => {
      console.log("success");
      this.ngOnInit();
    });
  }

  public processNextTeamLink(planners: MatListOption[]) {
    const planner: Planner = planners.pop().value;
    this.team.bindRelation("plannerList", planner).subscribe((value) => {
      console.log("planner relation added");
      console.log(value);
      this.teamStore.loadSingle(this.team.id).then((refreshedTeam) => {
        this.team = refreshedTeam;
        if (planners.length > 0) {
          this.processNextTeamLink(planners);
        } else {
          // this.ngOnInit();
          this.dialogRef.close();
        }
      });
    });
  }

  async onCancelClick() {
    this.dialogRef.close();
  }
}
